import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ctl from '@netlify/classnames-template-literals'
import { ClientLocaleNS } from 'lib/constants/locales'

import { FooterLink } from '../FooterLink/FooterLink'

type TProps = {}

const dotClassName = ctl(`flex h-2 w-2 flex-none rounded-half bg-text-secondary-alt max-md:hidden`)

const ServiceInfoBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.Common)

  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-3 text-center max-md:flex-col">
      <FooterLink href="/eula" className="text-palette-grey">
        {t('links.eula')}
      </FooterLink>
      <div className={dotClassName} />
      <FooterLink href="/service-terms" className="text-palette-grey">
        {t('links.service_terms')}
      </FooterLink>
      <div className={dotClassName} />
      <FooterLink href="/refund-policy" className="text-palette-grey">
        {t('links.refund_policy')}
      </FooterLink>
      <div className={dotClassName} />
      <FooterLink href="/cookie-policy" className="text-palette-grey">
        {t('links.cookie_policy')}
      </FooterLink>
      <div className={dotClassName} />
      <FooterLink href="/privacy-policy" className="text-palette-grey">
        {t('links.privacy_policy')}
      </FooterLink>
    </div>
  )
}

export { ServiceInfoBlock }
